import {TransportTimelineEvent, transportType} from '@ots-frontend/ots-data';
import {Text, ThemeIcon} from '@mantine/core'
import {useTranslation} from "react-i18next";
import {FormattedDateTime} from '../../date/FormattedDateTime/FormattedDateTime';
import {useMemo} from "react";
import {IconCircle} from "@tabler/icons-react";

type Props = {
    event: TransportTimelineEvent;
};

export const TransportTimelineItemTitle = (props: Props) => {
    const {event} = props;

    const {t} = useTranslation(["common"])

    const title = useMemo(() => {
        if (event.transportType === transportType.pickup) {
            return t("common.entity.dispatch.timeline.transport.title.pickup", "Load Picked-Up")
        } else {
            return t("common.entity.dispatch.timeline.transport.title.delivery", "Load Delivered")
        }
    }, [t, event.transportType])

    return <>{title}</>
}

export const TransportTimelineItemBullet = (props: Props) => {
    const {event} = props;

    const color = useMemo(() => {
        return event.transportType === transportType.pickup
            ? "dispatch-request-picked-up"
            : "dispatch-completed";
    }, [event.transportType])

    return (
        <ThemeIcon
            size={22}
            color={color}
            radius="xl"
        >
            <IconCircle size={12}/>
        </ThemeIcon>
    )
}

export const TransportTimelineItem = (props: Props) => {
    const {event} = props;

    const {t} = useTranslation(["common"])

    const summary = useMemo(() => {
        if (event.transportType === transportType.pickup) {
            return t("common.entity.dispatch.timeline.transport.summary.pickup", "{{personName}} picked-up load.", {
                personName: event.person ?? t("common.shared.user", "User")
            })
        } else {
            return t("common.entity.dispatch.timeline.transport.summary.delivery", "{{personName}} delivered load.", {
                personName: event.person ?? t("common.shared.user", "User")
            })
        }
    }, [t, event])

    return (
        <>
            <Text color="dimmed" size="sm">
                {summary}
            </Text>

            <Text size="xs" mt={4}>
                <FormattedDateTime date={event.date}/>
            </Text>
        </>
    );
};

TransportTimelineItem.Title = TransportTimelineItemTitle
TransportTimelineItem.Bullet = TransportTimelineItemBullet;
